import { DogBreederApplicationOtherAnimalLimited } from '@application/types';
import { enumSelectOptions } from '@application/utils';
import { DogBreederApplicationAccommodation } from '@gql/graphql';
import { InputLabel, InputRadioField, InputWrapper, Section } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import ApartmentGardenIcon from '../../assets/apartment-garden.svg';
import ApartmentIcon from '../../assets/apartment.svg';
import HouseGardenIcon from '../../assets/house-garden.svg';
import HouseIcon from '../../assets/house.svg';

const ICONS = {
  [DogBreederApplicationAccommodation.APPARTMENT]: ApartmentGardenIcon,
  [DogBreederApplicationAccommodation.APPARTMENT_NO_GARDEN]: ApartmentIcon,
  [DogBreederApplicationAccommodation.HOUSE]: HouseGardenIcon,
  [DogBreederApplicationAccommodation.HOUSE_NO_GARDEN]: HouseIcon,
};

export const Home = () => {
  const { translate } = useTranslation();
  const { translate: translateRessource } = useTranslation({
    keyPrefix: 'common.inputs',
  });

  return (
    <>
      <Section>
        <InputLabel required size="big">
          {translateRessource('home.label')}
        </InputLabel>
        <InputWrapper>
          <InputRadioField
            name="accommodation"
            separated
            options={enumSelectOptions(
              translate,
              'enum.dogBreederApplicationAccommodation',
              DogBreederApplicationAccommodation,
            ).map((option) => ({
              ...option,
              iconLeft: (
                <img src={ICONS[option.value as DogBreederApplicationAccommodation]} alt="icon" />
              ),
            }))}
          />
        </InputWrapper>
      </Section>

      <Section>
        <InputLabel required size="big">
          {translateRessource('otherAnimals.label')}
        </InputLabel>
        <InputWrapper>
          <InputRadioField<DogBreederApplicationOtherAnimalLimited>
            name="otherAnimals"
            separated
            multiple
            options={enumSelectOptions(
              translate,
              'enum.dogBreederApplicationOtherAnimal',
              DogBreederApplicationOtherAnimalLimited,
            )}
          />
        </InputWrapper>
      </Section>
    </>
  );
};
